import { useEffect, useState } from 'react'
import { toastErrorLog } from '../../../helpers/toastErrorLog'
import { formatearFecha } from '../../helpers/helper'
import { adjuntoBuilder } from '../../reutilizables/upload/adjuntoBuilder'
import * as archivoAdjuntoService from '../../servicios/archivoAdjuntoService'
import { Adjuntos } from './Adjuntos'
import { Responder } from './Responder'
import styles from './respuesta.module.css'

export const Respuesta = ({
  respuesta,
  usuario,
  mensaje,
  texto,
  errores,
  handleChange,
  submitRespuesta,
  valido,
  idPublicacion,
  adjuntoPendiente,
  setAdjuntoPendiente,
  manejarAdjunto,
  obtenerClaseAlineado,
  vendedorNombre
}) => {
  const respuestas = Array.isArray(respuesta) ? respuesta : respuesta.respuestas || []

  const [adjunto, setAdjunto] = useState([])

  const fetchAdjunto = async (idAdjunto, idMensaje) => {
    try {
      const { data } = await archivoAdjuntoService.buscarAdjuntosPorId(idAdjunto)

      const { dataAdjunto, adjunto } = data
      const previewAdjunto = await adjuntoBuilder(dataAdjunto, adjunto, adjunto.archivo, {
        preview: true
      })

      setAdjunto((prev) => {
        const listaActual = prev?.[idMensaje] || []

        const nuevoAdjunto = {
          ...previewAdjunto,
          idAdjunto: adjunto?.idAdjunto || idAdjunto
        }

        const yaExiste = listaActual.some((item) => item.idAdjunto === nuevoAdjunto.idAdjunto)

        return {
          ...prev,
          [idMensaje]: yaExiste ? listaActual : [...listaActual, nuevoAdjunto]
        }
      })
    } catch (error) {
      const mensaje = `Ocurrió un error al cargar los adjuntos`
      toastErrorLog(error, mensaje, 'preguntas')
    }
  }

  const adjuntos = respuestas.map((resp) => {
    let ids = resp.idsAdjuntos || resp?.IdsAdjuntosList || []

    if (typeof ids === 'string') {
      ids = ids.split(',')
    }

    return {
      idAdjunto: ids,
      idMensaje: resp.idMensaje
    }
  })

  useEffect(() => {
    adjuntos.forEach(({ idAdjunto, idMensaje }) => {
      idAdjunto.forEach((id) => {
        const yaExiste = adjunto?.[idMensaje]?.some((item) => item.idAdjunto === id)

        if (id && !yaExiste) {
          fetchAdjunto(id, idMensaje)
        }
      })
    })
  }, [respuestas, adjunto])

  return respuestas.map((resp) => (
    <div key={resp.idMensaje} className="text-secondary mb-2">
      <div className={`${obtenerClaseAlineado(resp.idUsuarioChat)}`}>
        <p className={styles.textoRespuesta}>
          {resp.texto}
          <br />
        </p>
        <Adjuntos adjunto={adjunto ? adjunto[resp.idMensaje] : null} />
        <span className={styles.fechaMensaje}>{formatearFecha(resp.fechaEscrito, 'FH', 'hs')}</span>
        <span className={styles.usuarioMensaje}>
          De:
          {resp.idUsuarioChat !== resp.idVendedor
            ? `${vendedorNombre} (vendedor)`
            : `${resp.comprador} (comprador)`}
        </span>
      </div>
      <Responder
        idComprador={mensaje.idComprador}
        idVendedor={mensaje.idVendedor}
        idUsuarioChat={resp.idUsuarioChat}
        idMensaje={resp.idMensaje}
        usuario={usuario}
        handleChange={handleChange}
        texto={texto}
        errores={errores}
        submitRespuesta={submitRespuesta}
        valido={valido}
        mensaje={mensaje}
        idPublicacion={idPublicacion}
        adjuntoPendiente={adjuntoPendiente}
        setAdjuntoPendiente={setAdjuntoPendiente}
        manejarAdjunto={manejarAdjunto}
      />
      {resp.respuestas && resp.respuestas.length > 0 && (
        <Respuesta
          respuesta={resp.respuestas}
          usuario={usuario}
          mensaje={mensaje}
          texto={texto}
          errores={errores}
          handleChange={handleChange}
          submitRespuesta={submitRespuesta}
          valido={valido}
          idPublicacion={idPublicacion}
          adjuntoPendiente={adjuntoPendiente}
          setAdjuntoPendiente={setAdjuntoPendiente}
          manejarAdjunto={manejarAdjunto}
          adjunto={adjunto}
          obtenerClaseAlineado={obtenerClaseAlineado}
          vendedorNombre={vendedorNombre}
        />
      )}
    </div>
  ))
}
